import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { DebugSnackbarComponent } from './debug-snackbar/debug-snackbar.component';
import { ActionSnackbarComponent } from './action-snackbar/action-snackbar.component';
import { Mockable } from '../../mocks/mockable.decorator';

/* eslint-disable @typescript-eslint/naming-convention */
export enum AlertLevel {
    Debug,       // If env is not production, Blue SnackBar with message
    Info,        // Normal SnackBar
    InfoSuccess, // SnackBar with "Success" background
    InfoFailure, // SnackBar with "Failure" background
    Warn,        // SnackBar with "warning" background
    Critical,    // Dialog with "critical" style
    ActionNeeded // Dialog with action buttons
}
/* eslint-enable @typescript-eslint/naming-convention */

export interface AlertAction {
    label: string;
    action: () => void;
    background?: 'success' | 'warn' | 'failure';
}

@Injectable({
    providedIn: 'root'
})
@Mockable
export class AlertsService {

    constructor(private readonly snackBar: MatSnackBar) { }

    public alert(message: string, level = AlertLevel.Info, action?: AlertAction) {
        switch (level) {
        case AlertLevel.Debug:
            this.alertDebug(message);
            break;
        case AlertLevel.Info:
        case AlertLevel.InfoSuccess:
        case AlertLevel.InfoFailure:
            this.alertSnackBar(message, level);
            break;
        case AlertLevel.Warn:
        case AlertLevel.Critical:
            this.alertStickySnackBar(message, level);
            break;
        case AlertLevel.ActionNeeded:
            this.alertActionSnackBar(message, action);
            break;
        }
    }

    private alertDebug(message: string) {
        if (!environment.production) {
            this.snackBar.openFromComponent(DebugSnackbarComponent, {
                data: message,
                announcementMessage: message,
                panelClass: 'debug'
            });
        }
    }

    private alertSnackBar(message: string, level: AlertLevel) {
        let panelClass = '';
        if (level === AlertLevel.InfoSuccess) {
            panelClass = 'success';
        } else if (level === AlertLevel.InfoFailure) {
            panelClass = 'failure';
        }
        this.snackBar.open(message, '', {panelClass, duration: 15000});
    }

    private alertStickySnackBar(message: string, level: AlertLevel) {
        const panelClass = level === AlertLevel.Warn ? 'warn' : 'failure';
        this.snackBar.open(message, '', {panelClass});
    }

    private alertActionSnackBar(message: string, action: AlertAction) {
        this.snackBar.openFromComponent(ActionSnackbarComponent, {
            data: {message, action},
            announcementMessage: message,
            panelClass: action.background
        });
    }
}
